import React from 'react';
import { AddressForm } from './Form';

export default function AddressesCreate(props) {
    return <AddressForm {...props} />;
}
